import './DynamicScopeTables.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getValuesFromDynamicFilterString } from '@sonar-software/sonar-ts-lib';
import { InitiativeScopeTable } from './InitiativeScopeTable';
import { ScopeTypeSubsection } from './ScopeTypeSubsection';
import { When } from 'react-if';
import { SonarObjectType, SonarV3SortDirection } from '@sonar-software/sonar-ts-types';
import { FeatureFlag, SchemaFormat } from '@sonar-software/sonar-core';
import React, { useState } from 'react';
import { useFeatureFlag } from '@hooks';
import { ScopeDisplaySelector } from './ScopeDisplaySelector';
import { TableModifier } from '@ui/table-modifier';
import { translateFilterQueryParamsToDynamicQueryLanguage, translateOrderQueryParamsToDynamicQueryLanguage } from '@ui/table-modifier/@arch/lib';
const filters = [
    {
        filterFormat: SchemaFormat.Primary,
        filterId: 'Name',
        filterLabel: COPY_SPECIFIC.NAME
    },
    {
        filterFormat: SchemaFormat.Owner,
        filterId: 'OwnerIds',
        filterLabel: COPY_SPECIFIC.OWNERS
    }
];
const compactFilters = [filters[0]];
const sortOptions = [
    {
        direction: SonarV3SortDirection.Ascending,
        key: 'Name',
        label: COPY_SPECIFIC.NAME
    }
];
const convertToDql = (queryParams) => ({
    filters: translateFilterQueryParamsToDynamicQueryLanguage(queryParams),
    ordering: translateOrderQueryParamsToDynamicQueryLanguage(queryParams)
});
const compactSortOptions = [];
export const DynamicScopeTables = ({ counts, initiativeId, queryParams, updateParams }) => {
    var _a, _b;
    const isDataDictionaryEnabled = useFeatureFlag(FeatureFlag.DataDictionary);
    const [displayType, setDisplayType] = useState('comfortable');
    const arrangers = isDataDictionaryEnabled ?
        React.createElement(ScopeDisplaySelector, { onChange: setDisplayType, value: displayType }) :
        null;
    const onlyScopeTypeIsPicklist = counts.length === 1 && SonarObjectType.SalesforcePicklistValue === counts[0][0];
    const isCompact = !isDataDictionaryEnabled || displayType === 'compact';
    const selectNamespace = `initiative-${initiativeId};`;
    return (React.createElement(React.Fragment, null,
        React.createElement(TableModifier, { className: 'dynamic-scope-table-filters', convertToDynamicQueryLanguage: convertToDql, customArrangers: arrangers, filterDisplayType: 'inline', filters: isCompact || onlyScopeTypeIsPicklist ? compactFilters : filters, filtersString: queryParams.filters, onChange: updateParams, orderString: queryParams.ordering, sonarObjectId: undefined, sonarObjectType: undefined, sortOptions: isCompact ? compactSortOptions : sortOptions }),
        React.createElement(When, { condition: isCompact },
            React.createElement(InitiativeScopeTable, { count: counts.reduce((prev, next) => prev + next[1], 0), dynamicNameFilter: queryParams.filters, initiativeId: initiativeId, nameFilter: (_b = (_a = getValuesFromDynamicFilterString(filters[0].filterId, queryParams.filters)[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '', selectNamespace: selectNamespace })),
        React.createElement(When, { condition: isDataDictionaryEnabled && displayType === 'comfortable' }, counts.map(([type, count]) => React.createElement(ScopeTypeSubsection, { count: count, initiativeId: initiativeId, key: type, overrideAutoCollapse: counts.length === 1, queryParams: queryParams, selectNamespace: selectNamespace, type: type })))));
};
